<template>
    <div class="ui-search-form clearfix">

        <!-- 表单区 -->
        <div class="form-list">
            <a-row>
                <a-col :span="6" v-for="(item,i) in fields" :key="i">
                    <a-row>
                        <a-col :span="8">
                            <div class="laba-text">
                                <span class="red" v-if="validRules[item.key] && validRules[item.key].required">*</span>
                                {{ item.label }}
                            </div>
                        </a-col>
                        <a-col :span="16">
                            <div class="search-form-item" :style="item.style || ''" :class="{'alert-item' : errKeys.indexOf(item.key) != -1,'search-item' : item.searchFlag}"
                                @keyup.enter="item.searchFlag && submitForm(item)"
                                >
                                <!-- 输入框 -->
                                <a-input v-if="item.type === 'text'"  size="small"
                                        @blur="validItem(item.key)"
                                        clearable
                                        v-model="formDatas[item.key]" :placeholder="item.placeholder || ''"></a-input>
                                <!-- 选择框 -->
                                <a-select v-if="item.type === 'select' || item.type === 'dictionary'" size="small" clearable
                                        @change="validItem(item.key)"
                                        v-model="formDatas[item.key]" :placeholder="item.placeholder || ''">
                                    <a-option
                                        v-for="oItem in item.options" :key="oItem.value"
                                        :label="oItem.label" :value="oItem.value">
                                    </a-option>
                                </a-select>
                                
                                <!-- 远程查询选择框 -->
                                <a-select v-if="item.type === 'remoteSelect'" size="small" clearable
                                        @change="validItem(item.key)"
                                        filterable remote :remote-method="(key) => romoteQuery(key,item)"
                                        :loading="loadingObj[item.key]"
                                        v-model="formDatas[item.key]" :placeholder="item.placeholder || ''">
                                    <a-option
                                        v-for="oItem in item.options" :key="oItem.value"
                                        :label="oItem.label" :value="oItem.value">
                                    </a-option>
                                </a-select>
                                
                                <!-- 日期选择 -->
                                <a-date-picker v-if="item.type === 'date'" size="small" type="date"
                                        @change="validItem(item.key)"
                                        v-model="formDatas[item.key]" :placeholder="item.placeholder || ''"></a-date-picker>
                                
                                <!-- 双日期选择 -->
                                <a-date-picker class="search-form-double-date" v-model="formDatas[item.key]" v-if="item.type === 'doubleDate'" type="daterange" :start-placeholder="item.placeholder0" :end-placeholder="item.placeholder1" size="small"></a-date-picker>
                
                                <!-- 搜索按钮 -->
                                <span class="search-btn" v-if="item.showSearchBtn" @click="submitForm(item)">
                                    <i class="a-icon-search"></i>
                                </span>

                            </div>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>


        </div>
        
        <!-- 按钮区 -->
        <div class="btn-list" v-if="btnFields && btnFields.length > 0">
            <a-button type="primary"
                v-for="(item,i) in btnFields" :key="i"
                :class="{'mar-r-10px' : i != btnFields.length - 1, [item.cssType] : 1}"
                :loading="item.loading"
                @click="btnClick(item)"
                >
                <i class="btn-icon" v-if="item.icon" :class="item.icon"></i>
                <span>{{item.label}}</span>
            </a-button>
        </div>

    </div>
</template>

<script>
import { DictionaryService } from '@common/services/dictionary.service';
export default {
    name : 'UiForm',
    components : {
        
    },
    props : {
        // 按钮设置列表
        btnFields : {
            type : Array,
            default : () => []
        },
        // 数据字典项
        dicList : {
            type : Array,
            default : () => {return []}
        },
        // 表单设置列表
        formFields : {
            type : Array,
            default : () => []
        },
        // 表单验证
        validRules : {
            type : Object,
            default : () => ({})
        },
    },
    watch : {
        formFields : {
            immediate : true,
            handler (newVal, oldVal) {
                this.fields = newVal;
            }
        }
    },
    data () {
        return {
            loading        : false,   // 加载中
            fields         : [],      // 配置项
            formDatas      : {},
            errKeys        : [],
            loadingObj     : {},      // 远程搜索加载中
            moreFilterFlag : false,   // 更多筛选状态
        }
    },
    computed : {
        
    },
    mounted () {
        // 获取数据字典并刷新
        this.$nextTick(() => this.refreshDicSt() );
    },
    methods : {
        // @public()
        // 设置数据
        setData (tarFormDatas) {
            this.formDatas = tarFormDatas;
        },

        // 按钮点击事件
        async btnClick (item) {
            this.$set(item,'loading',true);
            !item.disabled && item.run && await item.run();
            this.$set(item,'loading',false);
        },
        
        // 远程下拉列表获取
        romoteQuery (key,item) {
            this.$set(this.loadingObj,item.key,true);
            item.selectSearchFn(key,item).then(res => this.loadingObj[item.key] = false, 
                                                            err => this.loadingObj[item.key] = false);
        },

        // 点击切换更多筛选选择
        changeMoreFilterSt () {
            this.moreFilterFlag = !this.moreFilterFlag;
            this.$emit('filterStChange',this.moreFilterFlag);
        },

        // 数据改变触发回调
        changeItemFn (item) {
            if (item.key === 'coInsNo') this.refreshDicSt();   // 修改合作机构时，刷新项目编号、数据字典的下拉列表
            item.changeFn && item.changeFn(item,this.formDatas[item.key] || null);
        },

        // 修改合作机构时，刷新项目编号、数据字典的下拉列表
        async refreshDicSt () {
            if (!this.dicList || this.dicList.length == 0) return [];
            await this.refreshDic();
            this.refreshSt();
        },

        // 获取数据字典
        refreshDic () {
            if (!this.formDatas.coInsNo || !this.formDatas.coInsNo.value) return ;
            this.loading = true;
            return DictionaryService.getAllNeedDic(this.formDatas.coInsNo.value,this.dicList)
                        .catch((err) => this.$message.error('数据字典获取失败'))
                        .finally((fin) => this.loading = false)
        },

        // 数据字典刷新；项目刷新
        refreshSt () {
            this.fields.map(item => {
                if (item.type == 'dictionary') {
                    this.$set(this.formDatas, item.key, null);
                    let options = this.formDatas.coInsNo && this.formDatas.coInsNo.value ? DictionaryService.getOptions(this.formDatas.coInsNo.value, item.dicKey) : [];
                    this.$set(item,'options',options);
                }
                if (item.type == 'index' && item.indexExt.type == 'project') this.$set(this.formDatas, item.key, null);
            })
        },

        // ------------------------------操作相关结束

        // 表单提交事件
        submitForm (item) {
            item.run && item.run(this.getParams());
        },

        // @public
        // 获取表单数据
        getParams (formatFlag=true) {
            return ExtraDealService.formatData(this.fields, this.formDatas, formatFlag);
        },

        // @public
        // 验证并获取表单数据
        getValidFormData (formatFlag=true) {
            return new Promise((resolve,reject) => {
                this.validForm().then((res) => {
                    resolve( ExtraDealService.formatData(this.fields, this.formDatas, formatFlag) );
                },(err) => {
                    reject(err);
                });
            })
        },


        // 验证单项
        validItem (key) {
            let regRule = this.validRules[key];
            if (!regRule) return ;
            // 必填校验
            if (regRule.required && !this.formDatas[key]) this.errKeys.push(key);
            // 其它校验
            else if (regRule.validFn && !regRule.validFn(this.formDatas[key])) this.errKeys.push(key);
            // 通过校验
            else this.errKeys = this.errKeys.filter(item => item != key);
            this.errKeys = Array.from(new Set(this.errKeys));
        },

        // @public
        // 验证表单
        validForm () {
            return new Promise((resolve,reject) => {
                this.errKeys = [];
                Object.keys(this.validRules).map(item => {
                    let regRule = this.validRules[item];
                    if (!regRule) return ;
                    // 必填校验
                    if (regRule.required && !this.formDatas[item]) this.errKeys.push(item);
                    // 合作机构的必填校验
                    if (regRule.required && item == 'coInsNo' && (!this.formDatas[item] || !this.formDatas[item].value)) this.errKeys.push(item);
                    // 其它校验
                    if (regRule.validFn && !regRule.validFn(this.formDatas[item])) this.errKeys.push(item); 
                })
                // 去重
                this.errKeys = Array.from(new Set(this.errKeys));
                if (this.errKeys.length > 0) reject(this.errKeys);
                else resolve(true);
            });
        },
    }
}
</script>

<style lang="less" scoped>
.ui-search-form{
    width:100%;
    min-height:50px;
    padding-top:12px;
    display:flex;
    // 按钮区
    .btn-list{
        flex:2;
        text-align: center;
        margin-bottom:20px;
        .more-filters{
            display:inline-block;
            margin-left:10px;
            color:#3A65D7;
            cursor: pointer;
        }
        .btn-icon{
            margin-right:5px;
        }
    }
    
    .alert-item{
        border:1px solid #f00;
    }
    // 表单区
    .form-list{
        flex:8;
        line-height:28px;
        color:#44495A;
        .laba-text{
            text-align: right;
            padding-right:11px;
        }
        .search-form-item{
            display: inline-block;
            width:100%;
            height:30px;
            margin-bottom:20px;
            // padding-right是为了解决select在最右侧时，打开动画会导致滚动条异常问题
            padding-right:5px;
            .a-select{
                width:100%;
                display: inline-block;
                /deep/ i{
                    line-height:1;
                }
            }
            /deep/ input,/deep/ .a-input__icon{
                height:27px;
                line-height: 27px;
            }
            // 双日期选择
            .a-date-editor{
                width:100%;
                height:30px;
                &.search-form-double-date{
                    padding: 0 10px;
                    /deep/ input{
                        height:28px;
                        padding-right:10px;
                    }
                    /deep/ .a-input__icon{
                        vertical-align: top;
                    }
                    /deep/ .a-range-separator{
                        line-height:28px;
                    }
                }
            }

            // 索引框
            .index-box{
                width:100%;
                .a-input{
                    display:inline-block;

                }
                img{
                    display:inline-block;
                    margin-left:8px;
                    cursor: pointer;
                }
            }
            &.search-item{
                position:relative;
                /deep/ input{
                    height:30px;
                    padding-right:35px;
                }
                // 搜索框中的清除按钮
                /deep/ .a-input__suffix{
                    right:30px;
                }
                .search-btn{
                    position:absolute;
                    right:0;
                    top:0;
                    width:32px;
                    height:30px;
                    background:#4D7AF5;
                    text-align: center;
                    line-height:30px;
                    border-radius:3px;
                    cursor: pointer;
                    i{
                        font-size:16px;
                        color:#fff;
                    }
                }
            }
        }
    }
}

// 高级筛选
.high-search-btn{
    display: inline-block;
    height:25px;
    line-height:25px;
    border:1px solid #DCDFE6;
    img{
        width:8px;
        margin-right:5px;
        vertical-align: middle;
    }
    span{
        vertical-align: middle;
    }
}
</style>